// components/Apps/Quiz/QuizMeta.js
import React from 'react';
import PropTypes from 'prop-types';

const QuizMeta = ({ quizTitle, quizDescription, instructions }) => {
  return (
    <div className="quiz__header">
      {quizTitle && (
        <div className="text-section-title">{quizTitle}</div>
      )}
      {quizDescription && (
        <div className="quiz__description">{quizDescription}</div>
      )}
      {instructions && (
        <div className="quiz__instructions">{instructions}</div>
      )}
    </div>
  );
};

QuizMeta.propTypes = {
  quizTitle:       PropTypes.string,
  quizDescription: PropTypes.string,
  instructions:    PropTypes.string,
};

export default QuizMeta;